import { module } from 'modujs'
import modularLoad from 'modularload'
import loadingLogo from '../utils/loadingLogo';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        this.load = new modularLoad({
            enterDelay: 800,
            transitions: {
                listing: {
                    enterDelay: 500
                }
            }
        })

        this.load.on('loading', (transition, oldContainer) => {
            if (transition == 'listing') {
                this.call('scrollTo', { target: oldContainer.parentNode, options: { offset: -70, duration: 0.8 } }, 'Scroll')
            } else {
                loadingLogo()

                // Close menu
                requestAnimationFrame(() => {
                    this.call('close', null, 'ModalMenu')
                })
            }
        })

        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            const templateSlug = newContainer.dataset.template

            // Hubspot Meeting widget hotfix
            if(templateSlug == 'contact') {
                window.location.reload()
                return
            }

            this.call('destroy', oldContainer, 'app')
            this.call('update', newContainer, 'app')
        })

        this.load.on('ready', (transition) => {
            this.call('computeCurrentItem', null, 'Navigation')

            if (transition == 'listing') {
                this.call('update', null, 'Scroll')
            }
        })
    }

    goTo(obj) {
        this.load.goTo(obj.url, obj.transition);
    }
}
